import { email as emailValidator, is, pipe, string, trim } from 'valibot';

const emailSchema = pipe(string(), trim(), emailValidator());

export const isValidEmail = (email: string): boolean => {
  return is(emailSchema, email);
};
